import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

import { NutrientProgramService } from '@core/services/nutrient-program/nutrient-program';

/**
 * Keeps a member out of the Nutrient Program until the household's program has been materialized. Onboarding
 * provisions it asynchronously, so for a short window after signup the GET 404s and entering then would show an
 * empty, erroring program. Readiness is derived from the fetch (a real program came back) — reconciled on read
 * here and nudged live by the Onboarded SignalR signal — so this converges without polling. A member who is not
 * ready is sent home, where the entry points show the "setting up your household" state until the signal lands.
 */
export const nutrientProgramReadyChildGuard: CanActivateChildFn = async () => {
  const nutrientProgramService = inject(NutrientProgramService);
  const router = inject(Router);

  await nutrientProgramService.awaitReady();

  return nutrientProgramService.programReady() || router.createUrlTree(['home']);
};
